import { render, staticRenderFns } from "./AddProfession.vue?vue&type=template&id=592e400f&scoped=true"
import script from "./AddProfession.vue?vue&type=script&lang=js"
export * from "./AddProfession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e400f",
  null
  
)

export default component.exports